// extracted by mini-css-extract-plugin
module.exports = {"chart":"styles_chart__b4PYO","chart__text":"styles_chart__text__36PU2"};